import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";


import { Col, Flex, Tag } from "antd";
import { Alert } from "components/elements";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import * as services from "../../employee/services/employeeApi";
import {
  setCalendar,
  setEmployeeListForTeam,
  setIsLoading
} from "../../employee/slices/employeeSlice";
import styles from "../../employee/styles/EmployeeWorkinCalendar.module.css";
import { setCalendarEndDate, setCalendarStartDate, setIsHrView } from "../slices/myteamSlice";

function useMyTeamCalendar() {
  const dispatch = useDispatch();

  const { isLoading, calendar, employeeListForTeam } = useSelector((state) => state.employee);
  const { currentCompany, currentEmployee } = useSelector((state) => state.company);
  const { calendarStartDate, calendarEndDate, isHrView } = useSelector((state) => state.myteam);
  const { i18n, t } = useTranslation()
  const [renderType, setRenderType] = useState()
  const [year, setYear] = useState(dayjs().year())
  const [startDate, setStartDate] = useState(dayjs().startOf('month').format("YYYY-MM-DD"))
  const [endDate, setEndDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'))
  const [currentEmployeeTable, setCurrentEmployeeTable] = useState({})
  const [pagination, setPagination] = useState({ page: 0, size: 15, pageSize: 15 });
  const [total, setTotal] = useState(0);

  const getCalendarRange = (date) => {
    const firstDayOfMonth = dayjs(date).startOf('month');
    const lastDayOfMonth = dayjs(date).endOf('month');

    const calendarStart = firstDayOfMonth.day(0);

    const calendarEnd = lastDayOfMonth.day(6);

    return {
      start: calendarStart.format("YYYY-MM-DD"),
      end: calendarEnd.format("YYYY-MM-DD")
    };
  };

  useEffect(() => {
    dispatch(setCalendarStartDate())
    dispatch(setCalendarEndDate())
  }, [])

  useMemo(() => {
    if (calendarStartDate && calendarEndDate) {
      setStartDate(calendarStartDate)
      setEndDate(calendarEndDate)
    } else {
      const range = getCalendarRange(dayjs());
      setStartDate(range.start)
      setEndDate(range.end)
    }
  }, [calendarStartDate, calendarEndDate])

  const formatTime = (timeString) => {
    if (!timeString) return "Invalid Time";

    let time;

    if (timeString.includes('T')) {
      time = dayjs(timeString);
    } else {
      time = dayjs(`1970-01-01T${timeString}`);
    }

    return time.isValid() ? time.format("HH:mm") : "Invalid Time";
  };

  // * handle on year month change 
  const onChange = useCallback((values) => {
    const range = getCalendarRange(values);

    setYear(values?.$y);
    if (range.start !== startDate) {
      setStartDate(range.start);
      setEndDate(range.end);
    }
  }, [startDate])

  const getAllEmployee = useCallback(async (searchText = "") => {
    try {
      dispatch(setIsLoading(true));

      const requestParams = {
        companyId: currentCompany,
        actionId: currentEmployee,
        employeeId: currentEmployee,
        page: pagination.page,
        size: pagination.size,
        searchName: searchText
      };

      if (isHrView) {
        requestParams.roleHr = "Y";
      }

      const response = await services.getSubOrdinatesPaging(requestParams);

      dispatch(setEmployeeListForTeam(response?.data?.content || []))
      setTotal(response.data?.totalItems)
    } catch (error) {
      alert({ type: "error", resultObject: error })
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, currentEmployee, pagination.page, pagination.size, isHrView, dispatch])

  // useEffect(() => {
  //   getAllEmployee()
  // }, [currentCompany, currentEmployee, pagination, i18n.language, getAllEmployee])


  const getWorkInCalendar = useCallback(async (values) => {
    try {
      setCurrentEmployeeTable(values)
      dispatch(setIsLoading(true))
      const daysInMonth = dayjs(endDate).diff(dayjs(startDate), 'day') + 1
      const response = await services.getWorkIn({
        employeeId: values,
        companyId: currentCompany,
        year: year,
        startDate: startDate,
        endDate: endDate,
        page: 0,
        size: daysInMonth
      })
      dispatch(setCalendar(response?.data?.content))
    } catch (error) {
      Alert({ type: "error", resultObject: error });
    } finally {
      dispatch(setIsLoading(false))
    }
  }, [currentCompany, currentEmployee, year, startDate, endDate])


  const handleHrViewChange = useCallback((e) => {
    dispatch(setIsHrView(e.target.checked));
    setPagination({ page: 0, size: 15, pageSize: 15 });
  }, [dispatch]);

  const getMonthData = (value) => {
    if (value.month() === 8) {
      return 1394;
    }
  };

  function getBadgeColor(status) {
    switch (status) {
      case "Holiday":
        return "grey"
      case "Absent":
        return "red"
      case "Late":
        return "orange"
      case "Leave":
        return "yellow"
      default:
        return "success";
    }
  }

  function tagByShift(value, text) {
    switch (value) {
      case "กะทำงานปกติ":
        return (
          <Tag color="#E6F3FF" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#0085FF", fontSize: "14px" }}>{text}</span></Tag>
        )
      case "Normals":
        return (
          <Tag color="#E6F3FF" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#0085FF", fontSize: "14px" }}>{text}</span></Tag>
        )
      case "กะเช้า":
        return (
          <Tag color="#E6F3FF" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#0085FF", fontSize: "14px" }}>{text}</span></Tag>
        )
      case "กะเย็น":
        return (
          <Tag color="#E6F3FF" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#0085FF", fontSize: "14px" }}>{text}</span></Tag>
        )
      case "กะลาหยุด":
        return (
          <Tag color="#E6F3FF" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#0085FF", fontSize: "14px" }}>{text}</span></Tag>
        )
      default:
        return (<Tag color="#E6F3FF" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#0085FF", fontSize: "14px" }}>{text}</span></Tag>)
    }
  }

  function tagByStatus(value, text) {
    switch (value) {
      case "วันหยุดตามกะการทำงาน":
        return (
          <Tag color="#E8E8E8" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#585757", fontSize: "14px" }}>วันหยุดตามกะ</span></Tag>
        )
      case "Day Off":
        return (
          <Tag color="#E8E8E8" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#585757", fontSize: "14px" }}>{value}</span></Tag>
        )
      case "ลางาน":
        return (
          <Tag color="#E8E8E8" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#585757", fontSize: "14px" }}>{value}</span></Tag>
        )
      case "Leave":
        return (
          <Tag color="#E8E8E8" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#585757", fontSize: "14px" }}>{value}</span></Tag>
        )
      case "ขาดงาน":
        return (
          <Tag color="#FFECEC" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#E92C2C", fontSize: "14px" }}>{value}</span></Tag>
        )
      case "Absent":
        return (
          <Tag color="#FFECEC" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#E92C2C", fontSize: "14px" }}>{value}</span></Tag>
        )
      case "ออกงานก่อนเวลา":
        return (
          <Tag color="#FFF5E9" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#FFA726", fontSize: "14px" }}>{text}</span></Tag>
        )
      case "Early":
        return (
          <Tag color="#FFF5E9" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#FFA726", fontSize: "14px" }}>{text}</span></Tag>
        )
      case "เข้างานสาย":
        return (
          <Tag color="#FFF5E9" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#FFA726", fontSize: "14px" }}>{text}</span></Tag>
        )
      case "Late":
        return (
          <Tag color="#FFF5E9" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#FFA726", fontSize: "14px" }}>{text}</span></Tag>
        )
      case "เข้างานสายและออกงานก่อนเวลา":
        return (
          <Tag color="#FFF5E9" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#FFA726", fontSize: "14px" }}>{text}</span></Tag>
        )
      case "Late And Early":
        return (
          <Tag color="#FFF5E9" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#FFA726", fontSize: "14px" }}>{text}</span></Tag>
        )
      case "ปกติ":
        return (
          <Tag color="#E6F9EB" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#00BA34", fontSize: "14px" }}>{text}</span></Tag>
        )
      case "Normal":
        return (
          <Tag color="#E6F9EB" style={{ borderRadius: "4px", width: "max-content" }}><span style={{ color: "#00BA34", fontSize: "14px" }}>{text}</span></Tag>
        )
      default:
        return (<Tag color="processing">{value}</Tag>)
    }
  }

  const shiftColor = [
    {
      name: "กะการทำงาน",
      nameEn: "Work Shift",
      color: "#0085FF",
      bgColor: "#E6F3FF"
    },
    {
      name: "เข้าทำงานปกติ",
      nameEn: "Normals",
      color: "#00BA34",
      bgColor: "#E6F9EB"
    },
    {
      name: "ทำงานล่วงเวลาในวันหยุด",
      nameEn: "OT on holidays",
      color: "#6A51C1",
      bgColor: "#E1DCF3"
    },
    {
      name: "เข้างานสาย/กลับก่อน",
      nameEn: "Arrive late/leave early",
      color: "#FF9F2D",
      bgColor: "#FFF5E9"
    },
    {
      name: "วันหยุดตามกะ",
      nameEn: "Day Off",
      color: "#585757",
      bgColor: "#E8E8E8"
    },
    {
      name: "ขาดงาน",
      nameEn: "Absent",
      color: "#E92C2C",
      bgColor: "#FFECEC"
    },
    {
      name: "เปลี่ยนกะ/เเลกกะ/สลับกะ",
      nameEn: "Change shifts",
      color: "#E74AAB",
      bgColor: "#FADBEE"
    },
    {
      name: "คำขอลางาน",
      nameEn: "Leave request",
      color: "#585757",
      bgColor: "#E8E8E8"
    }
  ]

  const dateCellRender = useCallback((value) => {
    const filterDate = calendar?.filter((o) =>
      dayjs(value).format("YYYY-MM-DD") === dayjs(o?.date).format('YYYY-MM-DD')
    )
    return (
      <ul className={styles.events}>
        {
          filterDate?.length > 0 ? (
            filterDate?.map((o) => (
              <li key={o?.date}>
                {o?.status === "วันหยุดตามกะการทำงาน"
                  ? tagByStatus(i18n.language === 'en' ? o?.statusEn : o?.status)
                  : <Flex vertical style={{ gap: "7px" }}>
                    {/* กะการทำงาน */}
                    {tagByShift(i18n.language === 'en' ? o?.shiftNameEn : o?.shiftName, `${formatTime(o?.workInDateStart)} ${t("unit.to")} ${formatTime(o?.workInDateEnd)}`)}

                    {/* status */}

                    {o?.status ? o?.status === "ขาดงาน" && tagByStatus(i18n.language === 'en' ? o?.statusEn : o?.status) : null}
                    {o?.status ? (o?.status !== "ขาดงาน" && o?.status !== "ลางาน") && tagByStatus(i18n.language === "en" ? o?.statusEn : o?.status, `${formatTime(o?.checkInTime)} ${t("unit.to")} ${formatTime(o?.checkOutTime)}`) : null}

                    {o?.status ? o?.status === "ลางาน" && tagByStatus(i18n.language === 'en' ? o?.statusEn : o?.status) : null}
                  </Flex>}

              </li>
            ))
          ) : (
            <div></div>
          )
        }
      </ul>
    );

  }, [calendar]);

  const fullCellRender = useCallback(
    (date, info) => {
      const shiftDate = calendar?.find((o) =>
        dayjs(date).format("YYYY-MM-DD") === dayjs(o?.date).format('YYYY-MM-DD')
      );

      const backgroundColor = shiftDate?.status === "วันหยุดตามกะการทำงาน" ? "#f9f9f9" : "#ffffff";

      return (
        <div
          style={{
            minHeight: "15vh",
            padding: "12px",
            backgroundColor: backgroundColor,
            textAlign: "start"
          }}
        >
          <div style={{ marginBottom: "5px", textAlign: "start" }}>{date.format("DD")}</div>
          {dateCellRender(date)}
        </div>
      );
    },
    [dateCellRender]
  );

  // const cellRender = (current, info) => {
  //   if (info.type === "date") return dateCellRender(current);
  //   // if (info.type === "month") return monthCellRender(current);
  //   return info.originNode;
  // };

  const employeeMenu = useCallback(() => {
    return employeeListForTeam?.map(employee => {
      return {
        key: employee?.empId,
        tab: employee,
        id: employee?.id,
        name: employee?.name,
        nameEn: employee?.nameEn,
        imageData: employee?.imageData
      }
    }) || []
  }, [employeeListForTeam])

  useEffect(() => {
    if (currentCompany && window.location.pathname.startsWith("/my_team/")) {
      getAllEmployee()
    } else {
      dispatch(setEmployeeListForTeam([]))
    }
  }, [currentCompany, isHrView, pagination.page, pagination.size, getAllEmployee])

  // useEffect(() => {
  //   if (currentCompany && employeeListForTeam?.length) {
  //     getWorkInCalendar(employeeListForTeam[0]?.empId)
  //   }
  // }, [
  //   currentCompany,
  //   startDate,
  //   endDate,
  //   employeeListForTeam])

  useEffect(() => {

    if (currentCompany && employeeListForTeam?.length && window.location.pathname.startsWith("/my_team/")) {
      getWorkInCalendar(employeeListForTeam[0]?.empId);
    }
  }, [currentCompany, employeeListForTeam]);

  // useEffect(() => {
  //   if (currentCompany && employeeListForTeam?.length && currentEmployeeTable) {
  //     getWorkInCalendar(currentEmployeeTable);
  //   }
  // }, [startDate, endDate, currentEmployeeTable]);

  useEffect(() => {
    if (employeeListForTeam?.length && !currentEmployeeTable) {
      setCurrentEmployeeTable(employeeListForTeam[0].id);
    }
  }, [employeeListForTeam]);

  const CustomHeader = ({ value, type, onChange, onTypeChange }) => {
    const year = value.year();
    const month = value.month();

    const nextMonth = () => {
      const now = value.clone().month(month + 1);
      onChange(now);
    };

    const prevMonth = () => {
      const now = value.clone().month(month - 1);
      onChange(now);
    };

    return (
      <div style={{ padding: 10 }}>
        <button onClick={prevMonth}>Previous</button>
        <span>{year} - {value.format('MMMM')}</span>
        <button onClick={nextMonth}>Next</button>
      </div>
    );
  };

  function footerTag() {
    return (
      <Flex vertical gap={16}>
        <Flex gap={8} style={{ alignItems: "center", flexWrap: "wrap" }}>
          {shiftColor.slice(0, 4).map((shift, index) => (
            <Col span={[0, 1].includes(index) ? 4 : 6}>
              <Flex key={index} gap={8} style={{ alignItems: "center" }}>
                <div
                  style={{
                    backgroundColor: shift.color,
                    width: "15px",
                    height: "15px",
                    borderRadius: "50%",
                  }}
                />
                <Tag
                  color={shift.bgColor}
                  style={{ borderRadius: "4px", width: "max-content" }}
                >
                  <span style={{ color: shift.color }}>
                    {i18n.language === "en" ? shift.nameEn : shift.name}
                  </span>
                </Tag>
              </Flex>
            </Col>
          ))}
        </Flex>

        <Flex gap={8} style={{ alignItems: "center", flexWrap: "wrap" }}>
          {shiftColor.slice(4, 8).map((shift, index) => (
            <Col span={[0, 1].includes(index) ? 4 : 6}>
              <Flex key={index} gap={8} style={{ alignItems: "center" }}>
                <div
                  style={{
                    backgroundColor: shift.color,
                    width: "15px",
                    height: "15px",
                    borderRadius: "50%",
                  }}
                />
                <Tag
                  color={shift.bgColor}
                  style={{ borderRadius: "4px", width: "max-content" }}
                >
                  <span style={{ color: shift.color }}>
                    {i18n.language === "en" ? shift.nameEn : shift.name}
                  </span>
                </Tag>
              </Flex>
            </Col>
          ))}
        </Flex>
      </Flex>
    )
  }

  return {
    isLoading,
    calendar,
    getWorkInCalendar,
    cellRender: fullCellRender,
    onChange,
    employeeListForTeam,
    employeeMenu,
    CustomHeader,
    footerTag,
    currentEmployeeTable,
    pagination,
    setPagination,
    setTotal,
    total,
    getAllEmployee,
    isHrView,
    handleHrViewChange
  };
}

export default useMyTeamCalendar;
